import React from 'react';
import { NumericFormat, NumberFormatBaseProps, NumberFormatValues } from 'react-number-format';

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void;
	onBlur?: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
	name: string;
}

const MAX_VAL = 999999;
const withValueLimit = ({ floatValue }: NumberFormatValues) => (floatValue ? floatValue <= MAX_VAL : true);

const CurrencyFormat = React.forwardRef<NumberFormatBaseProps, CustomProps>((props, ref) => {
	const { onChange, onBlur, ...other } = props;
	return (
		<NumericFormat
			{...other}
			inputMode='decimal'
			getInputRef={ref}
			allowNegative={false}
			decimalScale={2}
			isAllowed={withValueLimit}
			onBlur={onBlur}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				});
			}}
			thousandSeparator
			valueIsNumericString
			prefix='£'
		/>
	);
});

CurrencyFormat.displayName = 'CurrencyFormat';

export default CurrencyFormat;
